import React, { FC } from "react";
import "./RefreshButton.scss";

export interface RefreshButtonProps {
    onClick(): void;
    showInLeft: boolean;
    showInRight: boolean;
    tabIndex?: string;
}

const RefreshButton: FC<RefreshButtonProps> = (props) => {
    return (
        <div
            id="xapp-widget-refresh"
            aria-label={"refresh chat"}
            aria-hidden={false}
            tabIndex={props.tabIndex ? Number(props.tabIndex) : 0}
            className={`refresh-button ${props.showInRight ? "positionRight" : props.showInLeft ? "positionLeft" : ""}`}
            onClick={props.onClick}>
        </div>
    );
};

export default RefreshButton;
